import React from 'react';
import type { ServicedeskBoardAppLayout as ServicedeskBoardType } from '@atlassian/jira-spa-apps-servicedesk-board/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { RouteContext } from '@atlassian/react-resource-router';

export const LazyServicedeskBoard = lazyForPaint<typeof ServicedeskBoardType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-board", jiraSpaEntry: "async-servicedesk-board" */ '@atlassian/jira-spa-apps-servicedesk-board'
		),
	),
);

export const LazyBoardSettings = lazyForPaint(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-jsm-board-settings", jiraSpaEntry: "async-jsm-board-settings" */ '@atlassian/jira-spa-apps-servicedesk-board-settings/src/ui'
		).then((module) => module.ServicedeskBoardSettingsAppLayout),
	),
);

export const ServicedeskBoard = (props: RouteContext) => {
	const { route, query } = props;

	if (route.name !== 'servicedesk-boards') {
		return null;
	}

	return query.config ? (
		<LazyPage
			Page={LazyBoardSettings}
			pageId="spa-apps/servicedesk/boards/board-settings"
			shouldShowSpinner
		/>
	) : (
		<LazyPage
			Page={LazyServicedeskBoard}
			pageId="spa-apps/servicedesk/boards/board"
			shouldShowSpinner
		/>
	);
};
